import { apiSlice } from "../api/apiSlice";

export const acUserLogApi = apiSlice.injectEndpoints({
  tagTypes: ["user-log"],
  endpoints: (builder) => ({
    getUserList: builder.query({
      query: () => "/apiV2/user-list",
      providesTags: ["user-log"],
    }),
    // createAcBranch: builder.mutation({
    //   query: (data) => ({
    //     url: "/apiV2/ac/branch-save",
    //     method: "POST",
    //     body: data,
    //   }),
    //   invalidatesTags: ["branch"],
    // }),
    userLogData: builder.mutation({
      query: (data) => ({
        url: "/apiV2/user-log",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["user-log"],
    }),
  }),
});

export const {
  useGetUserListQuery,
  // useCreateAcBranchMutation,
  useUserLogDataMutation,
} = acUserLogApi;
